import React, { Component } from 'react';
import { noDataImg, noDataImg2, noDataImg3 } from "../../common/baseConfig";
export default class NoneData extends Component {
  static propTypes = {

  };

  render() {
    const { type } = this.props;
    if (type === 1) {
      return (
        <div className="common-none-data">
          <img src={noDataImg} alt="" />
          <p>资源部小伙伴们，快马加鞭制作中......</p>
          <p>敬请期待</p>
        </div>
      );
    } else if (type === 2) {
      return (
        <div className="common-none-data">
          <img src={noDataImg2} alt="" />
          <p>暂无数据</p>
        </div>
      );
    } else {
      return (
        <div className="common-none-data">
          <img src={noDataImg3} alt="" />
          <p>暂无做题记录，快去题库练习吧！</p>
        </div>
      );
    }

  }
}



// WEBPACK FOOTER //
// ./src/features/common/NoneData.js